import { Box, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import EmployerSidebar from '../../Employer/EmployerSidebar'
import EmployerLetsStart from '../../Employer/EmployerLetsStart'
import RecentlyJoined from '../../Employer/RecentlyJoined'
import EmployerOverview from '../../Employer/EmployerOverview'
import EmployerTestimonial from '../../Employer/EmployerTestimonial'
import CandidateSideBar from '../Profile/CandidateSideBar'
import { getAllService, getUsersByProfile, getUserInformation } from '../../../actions/userAuth'
import { useDispatch, useSelector } from 'react-redux'
import Navbar from '../../Navbar'
import { useNavigate } from 'react-router-dom'
import RecommendedJobsCoachesService from '../RecommendedJobsCoachesService'
import CandidateCoaches from '../CandidateCoaches'
import BestServices from '../BestServices'
import Layout from '../../../assets/Layout'
import UserLayout from '../../../assets/UserLayout'
import CandidateCard from '../../../assets/cards/CandidateCard'
import CandidateChart from '../CandidateChart'

export default function CandidateDashboard() {
  const { user } = useSelector((state) => ({ ...state }));
  const [services, setServices] = useState([]);
  const [coaches, setCoaches] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!localStorage.getItem("user")) {
      navigate('/')
    }
  }, []);


  useEffect(() => {
    dispatch(getAllService({}, (data) => {
      setServices(data.data.data);
    }))
  }, []);

  useEffect(() => {
    dispatch(getUsersByProfile({ role: "COACH" }, (data) => {
      setCoaches(data.data.data);
    }))
  }, []); 

  return (
    <>
      <Layout>
        <UserLayout userRole={"candidate"}>
          <Box px={4}>
            <CandidateChart />
          </Box>
          <Box px={4}>
            <EmployerLetsStart />
          </Box>
          <Box px={4}>
            {/* <RecommendedJobsCoachesService coaches={coaches}/> */}
          </Box>
          <Box px={4}>
            <CandidateCoaches coaches={coaches}/>
          </Box>
          <Box px={4}>
            <EmployerTestimonial />
          </Box>
          <Box px={4}>
            <BestServices services={services} />
          </Box>
          <Box px={4}>
            <EmployerOverview />
          </Box>
        </UserLayout>
      </Layout>
    </>
  )
}
